export default function (x) {
  return String(x)
    .toLowerCase()
    .split(" ")
    .map((word) => (word ? word[0].toUpperCase() + word.substring(1) : ""))
    .join(" ")
}
